export default "__VITE_ASSET__e5f924a4__"